import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import './not-found.css'

const NotFound = (props) => {
  return (
    <div className="not-found-container1">
      <Helmet>
        <title>404 - Page Not Found | Help Me Out</title>
      </Helmet>

      <h3>Oops! Page Not Found</h3>

      <div className="not-found-container2">
        <h1 className="not-found-text2">404</h1>
      </div>

      <div className="not-found-container3">
        <h2 className="not-found-text3">
          We're sorry, but the page you requested could not be found. It may have been moved or deleted.
        </h2>
        <Link to="/" className="not-found-home-link">
          Return Home
        </Link>
      </div>
    </div>
  )
}

export default NotFound
